@if (heroLink(); as link) {
  <a
    class="app-shell__hero-link"
    [href]="link.url"
    [attr.target]="link.openInNewTab ? '_blank' : null"
    [attr.rel]="link.openInNewTab ? 'noopener noreferrer' : null"
    [attr.aria-label]="'layout.hero.imageAlt' | translate"
  >
    <ng-container *ngTemplateOutlet="heroPicture" />
  </a>
} @else {
  <ng-container *ngTemplateOutlet="heroPicture" />
}

<ng-template #heroPicture>
  <picture class="app-shell__hero-picture">
    <source media="(min-width: 1200px)" type="image/webp" [srcset]="desktopWebpSource()" />
    <source media="(min-width: 768px)" type="image/webp" [srcset]="desktopWebpSource()" />
    <source type="image/webp" [srcset]="mobileWebpSource()" />
    <img
      class="app-shell__hero-image"
      [src]="mobileWebpSource()"
      [attr.alt]="heroLink() ? '' : ('layout.hero.imageAlt' | translate)"
      width="720"
      height="472"
      fetchpriority="high"
    />
  </picture>
</ng-template>
